import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const withAuthRedirect = (Component) => {
  return function WrappedComponent(props) {
    const navigate = useNavigate();

    useEffect(() => {
      const token = sessionStorage.getItem("token");
      if (!token) {
        navigate("/");
      }
    }, [navigate]);

    return <Component {...props} />;
  };
};

export default withAuthRedirect;